import React from 'react';
import { useHistory } from 'react-router';
import $ from 'jquery';
import './SetPassword.css';
import successImg from '../../assets/success-modal.png';

const SetPassword = () => {
  const setPasswordValue = React.useRef(null);
  const confirmSetPasswordValue = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      set_password: setPasswordValue.current.value,
      confirm_passord: confirmSetPasswordValue.current.value,
    };
    return data;
  };

  // JQuery to trigger Modal

  $('.modal_btn').on('click', () => {
    $('.modal').css({
      display: 'block',
    });

    $('.set_pswd').css({
      opacity: '0',
    });
  });

  // to close the modal

  $('.close').on('click', () => {
    $('.modal').css({
      display: 'none',
    });

    $('.set_pswd').css({
      opacity: '1',
    });
  });

  //  End of Modals

  // To continue onboarding

  const history = useHistory();
  function goToProfile() {
    history.push('/explore');
  }

  return (
    <div className="set_pswd_container">
      <div className="set_pswd">
        <h2>New Password</h2>
        <p>Please enter your new password.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="password">
            <input
              type="password"
              name="set-password"
              className="set-password"
              required="required"
              ref={setPasswordValue}
              placeholder="******"
            />
          </label>

          <label htmlFor="password">
            <input
              type="password"
              name="confirm-password"
              className="confirm_passord"
              required="required"
              ref={confirmSetPasswordValue}
              placeholder="*******"
            />
          </label>

          <button
            type="button"
            className="btn modal_btn btn--primary"
            id="confirmBtn"
          >
            Confirm Password
          </button>
        </form>
      </div>

      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close">&times;</span>
          <img src={successImg} alt="success haelo" className="img" />
          <h2>Success</h2>
          <p>Your Password reset is successful.</p>
          <button
            type="button"
            className="btn btn--primary"
            id="continueBtn"
            onClick={goToProfile}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
